/** Regex aplicada ao CNPJ já concatenado (mesmo comportamento do template original). */
// Pós-julho/2026: os 12 primeiros podem conter A-Z/0-9; DV continua numérico (2 dígitos).
const CNPJ_DISPLAY_RE = /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/;

/**
 * Replica onFormataCnpj + máscara usada na listagem de Expedição (sem alterar regras).
 */
export function formatCnpjDigits(cnpj_base, cnpj_filial, cnpj_digito) {
  const baseRaw = (cnpj_base == null ? "" : cnpj_base).toString().toUpperCase().replace(/[^A-Z0-9]/g, "");
  const filialRaw = (cnpj_filial == null ? "" : cnpj_filial).toString().toUpperCase().replace(/[^A-Z0-9]/g, "");
  const digitoRaw = (cnpj_digito == null ? "" : cnpj_digito).toString().replace(/[^\d]/g, "");

  const base = "00000000".substring(0, Math.max(0, 8 - baseRaw.length)) + baseRaw;
  const filial = "0000".substring(0, Math.max(0, 4 - filialRaw.length)) + filialRaw;
  const digito = "00".substring(0, Math.max(0, 2 - digitoRaw.length)) + digitoRaw;

  return `${base}${filial}${digito}`;
}

export function formatCnpjForDisplay(cnpj_base, cnpj_filial, cnpj_digito) {
  return formatCnpjDigits(cnpj_base, cnpj_filial, cnpj_digito).replace(
    CNPJ_DISPLAY_RE,
    "$1.$2.$3/$4-$5"
  );
}